import type { LoginRequestPayload } from '@weft/api-definition';
import { getLocalStorageString, getRequiredLocalStorageString, localStorageExists, removeLocalStorageEntry, setLocalStorageString } from '../../utils/local-storage';
import { getPublicApi } from '../api';
import { ACCOUNT_ID_KEY, TOKEN_KEY } from './user-auth-consts';

export async function login(loginRequest: LoginRequestPayload) {
  const api = getPublicApi();

  const loginResponse = await api.login({ loginRequest }, {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': 'true',
    },
    credentials: 'include',
  });

  storeAccountId(loginResponse.user.accountId);
  storeToken(loginResponse.token);
}

export function logout() {
  deleteToken();
  location.reload();
}

export function isLoggedIn() {
  return localStorageExists(TOKEN_KEY);
}

export function getRequiredToken() {
  return getRequiredLocalStorageString(TOKEN_KEY);
}

export function getToken() {
  return getLocalStorageString(TOKEN_KEY);
}

export function storeToken(token: string) {
  setLocalStorageString(TOKEN_KEY, token); 
}

export function storeAccountId(accountId: string) {
  setLocalStorageString(ACCOUNT_ID_KEY, accountId);
}

function deleteToken() {
  removeLocalStorageEntry(TOKEN_KEY);
}

export async function refreshToken() {
  const api = getPublicApi();

  const { token } = await api.refreshToken({
    credentials: 'include',
  });

  storeToken(token);
}
